// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eaxC","fullView":"styles_fullView__2Mean"};